import { useEffect, useState } from "react";

const DEFAULT_LIGHT_BACKGROUND = "#fafafa";
const DEFAULT_DARK_BACKGROUND = "#09090b";

const DEFAULT_PRIMARY_COLOR = "28 87% 65%";

export default function useTheme() {
    const [theme, setTheme] = useState<"light" | "dark">("dark");

    useEffect(() => {
        const saved = localStorage.getItem("theme") as "light" | "dark";
        if (saved) {
            setTheme(saved);
            document.documentElement.setAttribute("data-theme", saved);
        } else {
            document.documentElement.setAttribute("data-theme", theme);
        }

        if (theme === "dark") {
            document.documentElement.style.removeProperty("--background-color");
        } else {
            document.documentElement.style.removeProperty("--background-color");
        }
    }, [theme]);

    const toggleTheme = () => {
        const newTheme = theme === "dark" ? "light" : "dark";
        setTheme(newTheme);
        document.documentElement.setAttribute("data-theme", newTheme);
        localStorage.setItem("theme", newTheme);
    };

    return { theme, toggleTheme };
}
